import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Tabs,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import React, { Fragment, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

import {
  InboxOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { loadAllEmploymentStatus } from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import {
  LeavePolicyGroupGetByCompanyId,
  loadAllLeavePolicy,
} from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import { loadAllSalaryComponents } from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";
import {
  addStaff,
  getCompanyNameByClientId,
  loadAllStaff,
} from "../../redux/rtk/features/user/userSlice";
import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import { statesData } from "../../utils/states";
import { getDepartments } from "../department/departmentApis";
import { getRoles } from "../role/roleApis";
import EmployeeEducationForm from "./EmployeeEducationForm";
import {
  getAllMaster,
  getCitiesByStateId,
} from "../../redux/rtk/features/masters/masterSlice";
import { buildCompanyOfficeSelectOptions } from "../../utils/companyOfficeLabel";

const { TabPane } = Tabs;
const { Option } = Select;
const { Dragger } = Upload;
const { Title } = Typography;

const SEARCHABLE_SELECT_PROPS = {
  showSearch: true,
  optionFilterProp: "label",
  filterOption: (input, option) =>
    String(option?.label ?? "")
      .toLowerCase()
      .includes(input.trim().toLowerCase()),
};

const sortByName = (items = [], nameKey) =>
  [...items].sort((a, b) =>
    String(a[nameKey] ?? "").localeCompare(String(b[nameKey] ?? ""), undefined, {
      sensitivity: "base",
    })
  );

const toSelectNumber = (value) =>
  value === null || value === undefined || value === ""
    ? undefined
    : Number(value);

const mapCityOptions = (cities = []) =>
  sortByName(cities, "CityName").map((city) => ({
    label: city.CityName,
    value: toSelectNumber(city.CityId),
  }));

const AddUser = React.forwardRef((props, ref) => {
  const [loader, setLoader] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const [enabledTabs, setEnabledTabs] = useState(["1"]);
  const dispatch = useDispatch();
  const { Title } = Typography;
  const { Option } = Select;
  const [list, setList] = useState(null);
  const [department, setDepartment] = useState(null);
  const citiesLoading = useSelector((state) => state?.masters?.loading);
  const [currentCities, setCurrentCities] = useState([]);
  const [permanentCities, setPermanentCities] = useState([]);
  const [salaryData, setSalaryData] = useState({ ctc: 0, inHandSalary: 0 });
  const [salary, setSalary] = useState(0);
  const users = useSelector((state) => state.users?.list) || [];
  const leavePolicyGroup =
    useSelector((state) => state?.leavePolicy?.leavePolicyGroup) || [];
  const [isSameAsCurrent, setIsSameAsCurrent] = useState(false);
  // console.log("users", users);
  useEffect(() => {
    dispatch(getAllMaster());
    dispatch(loadAllDesignation());
    // dispatch(loadAllEmploymentStatus());
    dispatch(loadAllShift());
    dispatch(loadAllWeeklyHoliday());
    dispatch(loadAllLeavePolicy());
    dispatch(loadAllSalaryComponents());
    dispatch(LeavePolicyGroupGetByCompanyId());
  }, []);
  const [isTabValid, setIsTabValid] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsSameAsCurrent(checked);
    if (checked) {
      setPermanentCities(currentCities);
      form.setFieldsValue({
        PStreetAddress: form.getFieldValue("CStreetAddress"),
        PCityId: form.getFieldValue("CCityId"),
        PStateId: form.getFieldValue("CStateId"),
        PZipCode: form.getFieldValue("CZipCode"),
        PCountryId: form.getFieldValue("CCountryId"),
      });
    } else {
      setPermanentCities([]);
      form.setFieldsValue({
        PStreetAddress: "",
        PCityId: undefined,
        PStateId: undefined,
        PZipCode: "",
        PCountryId: undefined,
      });
    }
  };
  const [education, setEducation] = useState([
    {
      degree: "",
      institution: "",
      fieldOfStudy: "",
      result: "",
      startDate: "",
      endDate: "",
    },
  ]);
  const [thumbFileList, setThumbFileList] = useState([]);
  const [isMarried, setIsMarried] = useState(false);
  const datePickerRef = useRef(null);
  // useseletor to get designations from redux
  const designation = useSelector((state) => state?.designations?.list) || [];
  const officeName = useSelector((state) => state?.users?.companyName) || [];
  const employmentStatus =
    useSelector((state) => state?.employmentStatus?.list) || [];
  const shift = useSelector((state) => state?.shift?.list) || [];
  // console.log("shift", shift);

  const weeklyHoliday = useSelector((state) => state.weeklyHoliday?.list) || [];
  const leavePolicy = useSelector((state) => state.leavePolicy?.list) || [];
  const salaryComponentData =
    useSelector((state) => state?.salaryComponents?.list) || [];
  const masterData = useSelector((state) => state?.masters?.masters) || [];

  const [joiningDate, setJoiningDate] = useState({ date: null });
  const [probationPeriod, setProbationPeriod] = useState({ date: null });
  const [salaryStartDate, setSalaryStartDate] = useState({ date: null });
  const [designationStartDate, setDesignationStartDate] = useState({
    date: null,
  });
  const [birthdayDate, setBirthdayDate] = useState({ date: null });
  const [birthAnniversaryDate, setBirthAnniversaryDate] = useState({
    date: null,
  });
  const dateJoinFormatted = joiningDate.date ? joiningDate.date : null;
  const dateProbationPeriod = probationPeriod.date
    ? probationPeriod.date
    : null;

  const dateSalaryFormatted = salaryStartDate.date
    ? salaryStartDate.date
    : null;
  const dateDesignationFormatted = designationStartDate.date
    ? designationStartDate.date
    : null;
  const birthdayFormatted = birthdayDate.date ? birthdayDate.date : null;
  const birthAnniversaryFormatted = birthAnniversaryDate.date
    ? birthAnniversaryDate.date
    : null;
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [rolesList, setRolesList] = useState([]);
  const companyNames = useSelector((state) => state?.user?.user) || [];
  // console.log("companyNames", companyNames);

  const companyId = getCompanyIdFromToken();
  // console.log("companyId", companyId);
  const [isQuickAddModalVisible, setIsQuickAddModalVisible] = useState(false);
  const [quickAddForm] = Form.useForm();
  // Dispatch action to fetch company names
  // useEffect(() => {
  //   dispatch(getCompanyNameByClientId(companyId));
  // }, [dispatch]);

  useEffect(() => {
    dispatch(loadAllStaff({ status: true }));
  }, []);

  // const handleFileUpload = ({ fileList }) => {
  // 	// console.log("fileList", fileList);
  // 	setThumbFileList(fileList);
  // };

  useEffect(() => {
    getRoles()
      .then((data) => {
        // Ensure data is an array
        const rolesArray = Array.isArray(data) ? data : (data?.data || data?.list || []);
        setRolesList(rolesArray);
      })
      .catch((error) => { 
        console.log("Error loading roles:", error);
        setRolesList([]);
      });
  }, []);

  useEffect(() => {
    getDepartments()
      .then((d) => {
        const sortedDepartment = d.sort((a, b) =>
          a.DepartmentName.localeCompare(b.DepartmentName)
        );
        setDepartment(sortedDepartment);
        // console.log("department", d);
      })
      // .catch((error) => // console.log(error));
  }, []);

  const [form] = Form.useForm();
  const currentStateId = Form.useWatch("CStateId", form);
  const permanentStateId = Form.useWatch("PStateId", form);

  const sortedStates = useMemo(
    () => sortByName(masterData?.StatesMaster, "StateName"),
    [masterData?.StatesMaster]
  );

  const sortedCountries = useMemo(
    () => sortByName(masterData?.CountriesMaster, "CountryName"),
    [masterData?.CountriesMaster]
  );

  const currentCityOptions = useMemo(
    () => mapCityOptions(currentCities),
    [currentCities]
  );

  const permanentCityOptions = useMemo(
    () => mapCityOptions(isSameAsCurrent ? currentCities : permanentCities),
    [currentCities, permanentCities, isSameAsCurrent]
  );

  const officeOptions = useMemo(
    () => buildCompanyOfficeSelectOptions(masterData),
    [masterData]
  );

  const reportingManagerOptions = useMemo(
    () =>
      sortByName(
        (users || []).filter((user) => Number(user.DataStatus) === 1),
        "EmployeeName"
      ).map((user) => ({
        label: user.EmployeeName,
        value: user.EmployeeId,
      })),
    [users]
  );

  const paymentTypeOptions = useMemo(
    () =>
      sortByName(
        (masterData?.PaymentTypeMaster || []).filter(
          (type) => type.DataStatus === 1
        ),
        "PaymentTypeName"
      ).map((type) => ({
        label: type.PaymentTypeName,
        value: toSelectNumber(type.PaymentTypeId),
      })),
    [masterData?.PaymentTypeMaster]
  );

  const handleStateChange = async (stateId, type) => {
    if (!stateId) {
      if (type === "C") {
        setCurrentCities([]);
        form.setFieldsValue({ CCityId: undefined });
      } else {
        setPermanentCities([]);
        form.setFieldsValue({ PCityId: undefined });
      }
      return;
    }

    const resultAction = await dispatch(getCitiesByStateId(stateId));
    const fetchedCities = Array.isArray(resultAction.payload)
      ? resultAction.payload
      : [];

    const selectedState = masterData?.StatesMaster?.find(
      (state) => Number(state.StateId) === Number(stateId)
    );

    if (type === "C") {
      setCurrentCities(fetchedCities);
      form.setFieldsValue({ CCityId: undefined });

      if (selectedState?.CountryId) {
        form.setFieldsValue({ CCountryId: Number(selectedState.CountryId) });
      }

      if (isSameAsCurrent) {
        setPermanentCities(fetchedCities);
        form.setFieldsValue({
          PStateId: Number(stateId),
          PCityId: undefined,
          ...(selectedState?.CountryId
            ? { PCountryId: Number(selectedState.CountryId) }
            : {}),
        });
      }
      return;
    }

    if (!isSameAsCurrent) {
      setPermanentCities(fetchedCities);
      form.setFieldsValue({ PCityId: undefined });
      if (selectedState?.CountryId) {
        form.setFieldsValue({ PCountryId: Number(selectedState.CountryId) });
      }
    }
  };

  const handleCityChange = (cityId, type) => {
    if (isSameAsCurrent && type === "C") {
      form.setFieldsValue({ PCityId: cityId });
    }
  };

  const validateUniqueUserName = (_, value) => {
    if (users.some((user) => user.UserName === value)) {
      return Promise.reject(new Error("This UserName is already taken."));
    }
    return Promise.resolve();
  };

  const validateUniqueEmail = (_, value) => {
    if (users.some((user) => user.email === value)) {
      return Promise.reject(new Error("This email is already in use."));
    }
    return Promise.resolve();
  };

  const calculateTotals = () => {
    const salaryComponents = {};

    // Iterate over salary component data and fetch values from the form
    salaryComponentData.forEach((component) => {
      const componentName = component.componentName;
      let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);

      // Check if the calculation type is '% of Basic'
      if (component.calculationType === "% of Basic") {
        const basicSalary = form.getFieldValue("salaryComponents.Basic");
        fieldValue = ((fieldValue || 0) * (basicSalary || 0)) / 100; // Calculate the percentage of Basic
      }

      salaryComponents[componentName] = fieldValue || 0;

      const amountFieldName = `${componentName}Amount`;
      form.setFieldsValue({
        [`salaryComponents.${amountFieldName}`]: fieldValue || 0,
      });
    });

    const incomeComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Income")
      .map((component) => salaryComponents[component.componentName] || 0);

    const deductionComponents = salaryComponentData
      ?.filter((component) => component.componentType === "Deduction")
      .map((component) => salaryComponents[component.componentName] || 0);

    const totalIncome = incomeComponents.reduce((acc, curr) => acc + curr, 0);
    const totalDeductions = deductionComponents.reduce(
      (acc, curr) => acc + curr,
      0
    );

    setSalaryData({
      ctc: totalIncome,
      inHandSalary: totalIncome - totalDeductions,
    });

    setSalary(salaryData.inHandSalary);

    // Update form fields with new salaryData values
    form.setFieldsValue({
      ctc: totalIncome,
      inHandSalary: totalIncome - totalDeductions,
    });
  };

  const handleFileUpload = (info, fieldKey) => {
    // console.log("lala", info);
    // console.log("land", fieldKey);
    const fileList = [...info.fileList].slice(-1);
    form.setFields([
      {
        name: ["documents", fieldKey, "file"],
        value: fileList,
      },
    ]);
    setThumbFileList(info.fileList);
    if (info.fileList.length > 0) {
      setSelectedDocument(info.fileList[0].originFileObj);
    }
  };
  const onFinish = async (values) => {
    const salaryComponents = {};
    salaryComponentData.forEach((component) => {
      const componentId = component.id;
      const componentName = component.componentName;
      let fieldValue = form.getFieldValue(`salaryComponents.${componentName}`);
      salaryComponents[componentId] = fieldValue;
    });

    // console.log("Bir, ann", birthdayFormatted, birthAnniversaryFormatted);

    // Construct the payload directly
    const payload = {
      ...values,
      startDate: values.startDate || values.JoinDate,
      StartDate: values.StartDate || values.JoinDate,
      dateJoinFormatted,
      dateProbationPeriod,
      dateSalaryFormatted,
      dateDesignationFormatted,
      salaryComponents,
      birthdayFormatted,
      birthAnniversaryFormatted,
      educations: values.educations || education,
      documents: values.documents || document,
      salary: salary || 0,
      file: thumbFileList[0]?.originFileObj,
      DataStatus: 1, // Add DataStatus=1
    };

    // console.log("Payload", payload);
    // console.log("File object:", thumbFileList[0]?.originFileObj);
    setLoader(true);

    try {
      payload.phone = `+91${values.phone}`;
      const resp = await dispatch(addStaff(payload));
      setLoader(false);

      if (resp.payload.message === "success") {
        quickAddForm.resetFields();
        setIsQuickAddModalVisible(false);
        // form.resetFields();
      } else if (resp.payload.message === "error") {
        // Handle error if needed
      }
    } catch (error) {
      // console.log(error.message);
      setLoader(false);
    }
  };

  const onQuickAddFinish = async (values) => {
    await onFinish(values);
  };
  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    // console.log("Failed:", errorInfo);
    // message.error("Please fill out all required fields!");
    notification.error({
      message: "Submission Error",
      description:
        "Please ensure all required fields are filled out before submitting.",
    });
  };

  const handleNext = async () => {
    try {
      let fieldsToValidate = [];
      switch (currentTab) {
        case "1":
          fieldsToValidate = [
            "FirstName",
            "LastName",
            "UserName",
            "password",
            //   "FatherName",
            //   "birthdate",
            //   "birthAnniversary",
            //   "MarriageAnniversary",
            //   "gender",
            //   "PanNumber",
            //   "AadharNumber",
          ];
          break;
        case "2":
          fieldsToValidate = ["phone"];
          break;
        case "3":
          fieldsToValidate = [
            // "street",
            // "city",
            // "state",
            // "zipCode",
            // "country",
            // "pAddress",
            // "pCity",
            // "pState",
            // "pZipCode",
            // "pCountry",
          ];
          break;
        case "4":
          fieldsToValidate = [
            // "JoinDate",
            "EmployeeCode",
            "employmentStatusId",
            // "IsEsicDeducted",
            "reportingManagerId",
            "departmentId",
            "roleId",
            // "shiftId",
            "leavePolicyId",
            "weeklyHolidayId",
            // "email",
            // "officialMailId",
            // "pfEligiblity",
            // "uan",
            // "paymentType",
          ];
          break;
        case "5":
          // fieldsToValidate = ["designationId", "StartDate"];
          break;
        case "6":
          // fieldsToValidate = ["startDate"];
          break;
        case "7":
          // fieldsToValidate = [
          //   "accountHolderName",
          //   "bankName",
          //   "accountNumber",
          //   "IFSC_code",
          // ];
          break;
        case "8":
          fieldsToValidate = [];
          break;
        default:
          break;
      }

      await form.validateFields(fieldsToValidate);

      // Enable the next tab
      const nextTab = String(Number(currentTab) + 1);
      if (!enabledTabs.includes(nextTab)) {
        setEnabledTabs([...enabledTabs, nextTab]);
      }

      setCurrentTab(nextTab);
    } catch (errorInfo) {
      // console.log("Validation Failed:", errorInfo);
    }
  };

  const handlePrevious = () => {
    const prevTab = String(Number(currentTab) - 1);
    setCurrentTab(prevTab);
  };

  const isTabDisabled = (tabKey) => {
    return enabledTabs.includes(tabKey);
  };

  const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"]; // blood groups

  const showQuickAddModal = () => {
    setIsQuickAddModalVisible(true);
  };

  React.useImperativeHandle(ref, () => ({
    showQuickAddModal
  }));

  const handleQuickAddCancel = () => {
    setIsQuickAddModalVisible(false);
    quickAddForm.resetFields();
  };

  return (
    <Fragment bordered={false}>
      {/* <UserPrivateComponent permission={"create-user"}> */}
      <div className="mr-top mt-2 p-2 ant-card add-user-container" style={{ maxWidth: "100%" }}>
        <Modal
          title="Quick Add Staff"
          open={isQuickAddModalVisible}
          onCancel={handleQuickAddCancel}
          footer={null}
          width={800}
        >
          <Form
            form={quickAddForm}
            name="quickAdd"
            onFinish={onQuickAddFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  label="Title"
                  name="TitleTypeId"
                  rules={[
                    { required: true, message: "Please select a title!" },
                  ]}
                >
                  <Select 
                    placeholder="Select Title" 
                    allowClear 
                    showSearch
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {masterData?.TitleTypeMaster?.map((title) => (
                      <Select.Option
                        key={title.TitleTypeId}
                        value={title.TitleTypeId}
                      >
                        {title.TitleTypeName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="First Name"
                  name="FirstName"
                  rules={[
                    { required: true, message: "Please input First Name!" },
                  ]}
                >
                  <Input placeholder="First Name" />
                </Form.Item>
                 <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Middle Name"
                      name="MiddleName"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Middle Name!",
                      //   },
                      // ]}
                    >
                      <Input tabIndex={3} placeholder="Middle Name" />
                    </Form.Item>
                 <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Last Name"
                      name="LastName"
                      // rules={[
                      //   { required: true, message: "Please input Last Name!" },
                      // ]}
                    >
                      <Input tabIndex={4} placeholder="Last Name" />
                    </Form.Item>
                    
                <Form.Item
                  label="Phone"
                  name="PhoneNumber"
                  rules={[
                    { required: true, message: "Please input phone number!" },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit phone number!",
                    },
                  ]}
                >
                  <Input placeholder="Phone" maxLength={10} addonBefore="+91" />
                </Form.Item>
                <Form.Item
                  label="Personal Email"
                  name="EmailId"
                  rules={[
                    { required: true, message: "Please input email!" },
                    { type: "email", message: "Please enter a valid email!" },
                    { validator: validateUniqueEmail },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
                <Form.Item
                  label="Joining Date"
                  name="JoinDate"
                  rules={[
                    { required: true, message: "Please input joining date!" },
                  ]}
                >
                  <DatePicker
                    className="w-full"
                    format="DD-MM-YYYY"
                    onChange={(date, dateString) =>
                      setJoiningDate({ date: dateString })
                    }
                    inputReadOnly
                  />
                </Form.Item>
                <Form.Item
                  label="Employee Code"
                  name="EmployeeCode"
                  rules={[
                    { required: true, message: "Please input Employee Code!" },
                  ]}
                >
                  <Input placeholder="Emp-001" />
                </Form.Item>
              </Col>
              <Col span={12}>
                
                <Form.Item
                  label="Employee Status"
                  name="EmploymentTypeId"
                  rules={[
                    {
                      required: true,
                      message: "Please select Employment Status!",
                    },
                  ]}
                >
                  <Select 
                    placeholder="Select Status" 
                    showSearch 
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {masterData?.EmploymentTypeMaster?.map((status) => (
                      <Select.Option
                        key={status.EmploymentTypeId}
                        value={status.EmploymentTypeId}
                      >
                        {status.EmploymentTypeName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.EmploymentTypeId !==
                    currentValues.EmploymentTypeId
                  }
                >
                  {({ getFieldValue }) => (
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label={
                        getFieldValue("EmploymentTypeId") &&
                        masterData?.EmploymentTypeMaster?.find(
                          (status) =>
                            status.EmploymentTypeId ===
                            getFieldValue("EmploymentTypeId")
                        )?.EmploymentTypeName === "Probation" ? (
                          <span>
                            <span style={{ color: "red" }}>* </span>Probation
                            Period
                          </span>
                        ) : (
                          "Probation Period"
                        )
                      }
                      name="ProbationComplateDate"
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const employmentTypeId =
                              getFieldValue("EmploymentTypeId");
                            const isProbation =
                              masterData?.EmploymentTypeMaster?.find(
                                (status) =>
                                  status.EmploymentTypeId === employmentTypeId
                              )?.EmploymentTypeName === "Probation";
                            if (isProbation && !value) {
                              return Promise.reject(
                                new Error(
                                  "Probation date is required when Employment Status is Probation!"
                                )
                              );
                            }
                            const JoinDate = getFieldValue("JoinDate");
                            if (
                              !value ||
                              !JoinDate ||
                              value.isAfter(JoinDate)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                "Probation date must be after the joining date!"
                              )
                            );
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="date-picker hr-staffs-date-picker"
                        onChange={(date, dateString) =>
                          setProbationPeriod({ date: dateString })
                        }
                        format="DD-MM-YYYY"
                        inputReadOnly
                      />
                    </Form.Item>
                  )}
                </Form.Item>
                <Form.Item
                  label="Role"
                  name="RoleId"
                  rules={[{ required: true, message: "Please select Role!" }]}
                >
                  <Select 
                    placeholder="Select Role" 
                    showSearch 
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {Array.isArray(rolesList) && rolesList.map((role) => (
                      <Select.Option key={role.RoleId} value={role.RoleId}>
                        {role.RoleName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Department"
                  name="DepartmentId"
                  rules={[
                    { required: true, message: "Please select Department!" },
                  ]}
                >
                  <Select 
                    placeholder="Select Department" 
                    showSearch 
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {masterData?.DepartmentMaster?.map((dept) => (
                      <Select.Option
                        key={dept.DepartmentId}
                        value={dept.DepartmentId}
                      >
                        {dept.DepartmentName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
               <Form.Item
                  label="Designation"
                  name="DesignationId"
                  rules={[
                    { required: true, message: "Please select Designation!" },
                  ]}
                >
                  <Select
                    placeholder="Select Designation"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {masterData?.DesignationMaster?.map((des) => (
                      <Select.Option
                        key={des.DesignationId}
                        value={des.DesignationId}
                      >
                        {des.DesignationName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Reporting Manager"
                  name="ReportingToId"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please select a Reporting Manager!",
                  //   },
                  // ]}
                >
                  <Select
                    placeholder="Select Reporting Manager"
                    allowClear
                    {...SEARCHABLE_SELECT_PROPS}
                    options={reportingManagerOptions}
                  />
                </Form.Item>
                <Form.Item
                  label="Office"
                  name="CompanyOfficeId"
                  rules={[{ required: true, message: "Please select Office!" }]}
                >
                  <Select
                    placeholder="Select Office"
                    allowClear
                    {...SEARCHABLE_SELECT_PROPS}
                    options={officeOptions}
                  />
                </Form.Item>
                
                <Form.Item
                  label="Shift"
                  name="ShiftId"
                  rules={[{ required: true, message: "Please select Shift!" }]}
                >
                  <Select 
                    placeholder="Select Shift" 
                    showSearch 
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {shift?.map((s) => (
                      <Select.Option key={s.ShiftId} value={s.ShiftId}>
                        {s.ShiftName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Working Days"
                  name="WeeklyWorkingDaysId"
                  rules={[
                    { required: true, message: "Please select Working Days!" },
                  ]}
                >
                  <Select
                    placeholder="Select Working Days"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {weeklyHoliday?.map((wh) => (
                      <Select.Option
                        key={wh.WeeklyWorkingDaysId}
                        value={wh.WeeklyWorkingDaysId}
                      >
                        {wh.WeeklyWorkingDaysName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                
              </Col>
            </Row>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-blue-600 hover:bg-blue-700"
                loading={loader}
              >
                Add Staff
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Form
          size="small"
          form={form}
          name="basic"
          labelCol={{
            span: 10,
          }}
          wrapperCol={{
            span: 22,
          }}
          initialValues={{
            remember: true,
            salaryComponents: {},
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          onValuesChange={calculateTotals}
        >
          <Tabs activeKey={currentTab} onChange={setCurrentTab}>
            {/* <TabPane tab="User Information" key="1" disabled={isTabDisabled("1")}> */}

            <TabPane tab="User Information" key="1">
              <Col span={24} className="gutter-row form-color">
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Title"
                      name="TitleTypeId"
                      rules={[
                        {
                          required: true,
                          message: "Please select your gender!",
                        },
                      ]}
                    >
                      <Select
                        tabIndex={1}
                        placeholder="Select Title"
                        allowClear
                        showSearch
                      >
                        {masterData?.TitleTypeMaster?.map((title) => (
                          <Select.Option
                            key={title.TitleTypeId}
                            value={title.TitleTypeId}
                          >
                            {title.TitleTypeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Middle Name"
                      name="MiddleName"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Middle Name!",
                      //   },
                      // ]}
                    >
                      <Input tabIndex={3} placeholder="Middle Name" />
                    </Form.Item>

                    {/* <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="User Name"
                      name="UserName"
                      rules={[
                        { required: true, message: "Please input User Name!" },
                        { validator: validateUniqueUserName },
                      ]}
                    >
                      <Input placeholder="User Name" />
                    </Form.Item> */}

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Father's Name"
                      name="FatherName"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Father's Name!",
                      //   },
                      // ]}
                    >
                      <Input tabIndex={5} placeholder="Father's Name" />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label={
                        <span>
                          Birthdate
                          <Tooltip title="As Per Document">
                            <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                          </Tooltip>
                        </span>
                      }
                      name="BirthDate"
                      // tabIndex={7}

                      // rules={[
                      //   { required: true, message: "Please input Birthdate!" },
                      // ]}
                    >
                      <div
                        tabIndex={7}
                        onFocus={() => {
                          // Safe check for ref before calling focus
                          if (
                            datePickerRef.current &&
                            datePickerRef.current.input
                          ) {
                            datePickerRef.current.input.focus();
                          }
                        }}
                      >
                        <DatePicker
                          //                     inputReadOnly={false}  // Ensure input can be focused
                          // getPopupContainer={trigger => trigger.parentNode}
                          ref={datePickerRef}
                          format="DD-MM-YYYY"
                          placeholder="Select Birthdate"
                          style={{ width: "100%" }}
                          onChange={(date, dateString) => {
                            setBirthdayDate({ date: dateString });
                            // console.log("Birthday Date:", birthdayDate);
                          }}
                        />
                      </div>
                    </Form.Item>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Phone"
                      name="PhoneNumber"
                      rules={[
                        {
                          required: true,
                          message: "Please input phone number!",
                        },
                        {
                          pattern: /^[0-9]{10}$/,
                          message:
                            "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                    >
                      <Input
                        tabIndex={9}
                        placeholder="Phone"
                        maxLength={10}
                        addonBefore="+91"
                      />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Gender"
                      name="GenderTypeId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select your gender!",
                      //   },
                      // ]}
                    >
                      <Select
                        tabIndex={11}
                        placeholder="Select Gender"
                        allowClear
                        showSearch
                      >
                        {masterData?.GenderTypeMaster?.map((gender) => (
                          <Select.Option
                            key={gender.GenderTypeId}
                            value={gender.GenderTypeId}
                          >
                            {gender.GenderTypeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="PAN Card Number"
                      name="PanNumber"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input PAN Card Number!",
                      //   },
                      // ]}
                    >
                      <Input tabIndex={13} placeholder="PAN Card Number" />
                    </Form.Item>
                  </Col>

                  {/* Second Column */}
                  <Col span={12}>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="First Name"
                      name="FirstName"
                      rules={[
                        { required: true, message: "Please input First Name!" },
                      ]}
                    >
                      <Input tabIndex={2} placeholder="First Name" />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Last Name"
                      name="LastName"
                      // rules={[
                      //   { required: true, message: "Please input Last Name!" },
                      // ]}
                    >
                      <Input tabIndex={4} placeholder="Last Name" />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label={
                        <span>
                          Birth Anniversary
                          <Tooltip title="Original Date of Birth">
                            <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                          </Tooltip>
                        </span>
                      }
                      name="BirthAnniversary"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Birth Anniversary!",
                      //   },
                      // ]}
                    >
                      <div
                        tabIndex={6}
                        onFocus={() => {
                          // Safe check for ref before calling focus
                          if (
                            datePickerRef.current &&
                            datePickerRef.current.input
                          ) {
                            datePickerRef.current.input.focus();
                          }
                        }}
                      >
                        <DatePicker
                          // tabIndex={6}
                          ref={datePickerRef}
                          format="DD-MM-YYYY"
                          placeholder="Select Birth Anniversary"
                          style={{ width: "100%" }}
                          onChange={(date, dateString) => {
                            setBirthAnniversaryDate({ date: dateString });
                            // console.log("Birthday Date:", birthAnniversaryDate);
                          }}
                        />
                      </div>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Marital Status"
                      name="MaritalStatus"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select marital status!",
                      //   },
                      // ]}
                    >
                      <Select
                        tabIndex={8}
                        placeholder="Select Marital Status"
                        allowClear
                        showSearch
                      >
                        {masterData?.MaritalStatusTypeMaster?.map((status) => (
                          <Select.Option
                            key={status.MaritalStatusTypeId}
                            value={status.MaritalStatusTypeId}
                          >
                            {status.MaritalStatusTypeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Alternate Number"
                      name="AlternateNumber"
                      // rules={[
                      //   {
                      //     pattern: /^[0-9]{10}$/,
                      //     message:
                      //       "Please enter a valid 10-digit Emergency Contact Number!",
                      //   },
                      // ]}
                    >
                      <Input
                        tabIndex={10}
                        placeholder="Phone"
                        maxLength={10}
                        addonBefore="+91"
                      />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Blood Group"
                      name="BloodGroupTypeId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select blood group!",
                      //   },
                      // ]}
                    >
                      <Select
                        tabIndex={12}
                        placeholder="Select Blood Group"
                        allowClear
                        showSearch
                      >
                        {masterData?.BloodGroupTypeMaster?.map((bg) => (
                          <Select.Option
                            key={bg.BloodGroupTypeId}
                            value={bg.BloodGroupTypeId}
                          >
                            {bg.BloodGroupTypeName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Aadhar Card Number"
                      name="AadharNumber"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Aadhar Card Number!",
                      //   },
                      // ]}
                    >
                      <Input tabIndex={14} placeholder="Aadhar Card Number" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </TabPane>

            <TabPane
              tab="Contact Details"
              key="2"
              disabled={isTabDisabled("2")}
            >
              <Col span={12} className="gutter-row">
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Contact Details
                </h2>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Contact Person Name"
                  name="ContactPersonName"
                >
                  <Input placeholder="Contact Person Name" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Contact Person EmailId"
                  name="ContactPersonEmailId"
                >
                  <Input placeholder="Contact Person EmailId" />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Contact Person Number"
                  name="ContactPersonNumber"
                  // rules={[
                  //   {
                  //     pattern: /^[0-9]{10}$/,
                  //     message: "Please enter a valid 10-digit Contact Number!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Phone" maxLength={10} addonBefore="+91" />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Contact Person Alternate Number"
                  name="ContactPersonAlternateNumber"
                  // rules={[
                  //   {
                  //     pattern: /^[0-9]{10}$/,
                  //     message: "Please enter a valid 10-digit Contact Number!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Phone" maxLength={10} addonBefore="+91" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Contact Person Relation"
                  name="ContactPersonRelationId"
                >
                  <Select
                    placeholder="Select or type relation"
                    showSearch
                    allowClear
                    mode="combobox"
                  >
                    {masterData?.RelationTypeMaster?.map((relation) => (
                      <Select.Option
                        key={relation.RelationTypeId}
                        value={relation.RelationTypeId}
                      >
                        {relation.RelationTypeName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </TabPane>

            <TabPane
              tab="Address Information"
              key="3"
              disabled={isTabDisabled("3")}
            >
              <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                Address Information
              </h2>

              <Row gutter={24}>
                <Col span={12}>
                  <Card
                    title="Current Address"
                    bordered={true}
                    style={{ height: "100%" }}
                  >
                    <Form.Item
                      label="House Address"
                      name="CStreetAddress"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input house address!",
                      //   },
                      // ]}
                    >
                      <Input placeholder="Enter Address" />
                    </Form.Item>

                    <Form.Item
                      label="State"
                      name="CStateId"
                      // rules={[
                      //   { required: true, message: "Please select a state!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select a state"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        onChange={(value) => handleStateChange(value, "C")}
                        options={sortedStates.map((state) => ({
                          label: state.StateName,
                          value: toSelectNumber(state.StateId),
                        }))}
                      />
                    </Form.Item>

                    <Form.Item
                      label="City"
                      name="CCityId"
                      // rules={[
                      //   { required: true, message: "Please select a city!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select a city"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        disabled={!currentStateId}
                        loading={citiesLoading}
                        options={currentCityOptions}
                        onChange={(value) => handleCityChange(value, "C")}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Zip Code"
                      name="CZipCode"
                      // rules={[
                      //   { required: true, message: "Please input Zip Code!" },
                      //   {
                      //     pattern: /^[0-9]{6}$/,
                      //     message: "Please enter a valid 6-digit Zip Code!",
                      //   },
                      // ]}
                    >
                      <Input placeholder="000000" maxLength={6} />
                    </Form.Item>

                    <Form.Item
                      label="Country"
                      name="CCountryId"
                      // rules={[
                      //   { required: true, message: "Please input Country!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select country"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        options={sortedCountries.map((country) => ({
                          label: country.CountryName,
                          value: toSelectNumber(country.CountryId),
                        }))}
                      />
                    </Form.Item>
                  </Card>
                </Col>

                <Col span={12}>
                  <Card
                    title="Permanent Address"
                    bordered={true}
                    style={{ height: "100%" }}
                  >
                    <Form.Item
                      label="House Address"
                      name="PStreetAddress"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input house address!",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="Enter Address"
                        disabled={isSameAsCurrent}
                      />
                    </Form.Item>

                    <Form.Item
                      label="State"
                      name="PStateId"
                      // rules={[
                      //   { required: true, message: "Please select a state!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select a state"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        onChange={(value) => handleStateChange(value, "P")}
                        disabled={isSameAsCurrent}
                        options={sortedStates.map((state) => ({
                          label: state.StateName,
                          value: toSelectNumber(state.StateId),
                        }))}
                      />
                    </Form.Item>

                    <Form.Item
                      label="City"
                      name="PCityId"
                      // rules={[
                      //   { required: true, message: "Please select a city!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select a city"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        disabled={isSameAsCurrent || !permanentStateId}
                        loading={citiesLoading}
                        options={permanentCityOptions}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Zip Code"
                      name="PZipCode"
                      // rules={[
                      //   { required: true, message: "Please input Zip Code!" },
                      //   {
                      //     pattern: /^[0-9]{6}$/,
                      //     message: "Please enter a valid 6-digit Zip Code!",
                      //   },
                      // ]}
                    >
                      <Input
                        placeholder="000000"
                        maxLength={6}
                        disabled={isSameAsCurrent}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Country"
                      name="PCountryId"
                      // rules={[
                      //   { required: true, message: "Please input Country!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select country"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        disabled={isSameAsCurrent}
                        options={sortedCountries.map((country) => ({
                          label: country.CountryName,
                          value: toSelectNumber(country.CountryId),
                        }))}
                      />
                    </Form.Item>
                  </Card>
                </Col>
              </Row>

              <Row justify="center" style={{ marginTop: "20px" }}>
                <Col>
                  <Form.Item name="IsSameAsCurrent" valuePropName="checked">
                    <Checkbox onChange={handleCheckboxChange}>
                      Current address and permanent address are the same
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </TabPane>

            <TabPane
              tab="Employee Information"
              key="4"
              disabled={isTabDisabled("4")}
            >
              <Col span={24} className="gutter-row form-color">
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Employee Information
                </h2>

                <Row gutter={[16, 16]}>
                  {/* First Column */}
                  <Col span={12}>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Joining Date"
                      name="JoinDate"
                      rules={[
                        {
                          required: true,
                          message: "Please input joining date!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const JoinDate = getFieldValue("JoinDate");
                            if (!value || !JoinDate) {
                              return Promise.resolve();
                            }
                            if (value.unix() >= JoinDate.unix()) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                "Probation period end date must be after or equal to the joining date!"
                              )
                            );
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="date-picker hr-staffs-date-picker"
                        // onChange={(date, dateString) => {
                        // 	setJoiningDate(dateString); // Store joining date
                        // 	form.validateFields(['probationPeriod', 'startDate', 'StartDate']); // Trigger validation for dependent fields
                        // }}

                        onChange={(date, dateString) => {
                          if (date) {
                            const JoinDate = date.startOf("day"); // Sets the time to 00:00:00
                            setJoiningDate({ date: dateString });
                            // console.log("joiningDate", joiningDate);
                            // console.log("joiningDate", { date: dateString });
                          } else {
                            setJoiningDate(null); // Handle case where date is cleared
                          }
                          // setJoinDate(date);
                          form.validateFields([
                            "probationPeriod",
                            "startDate",
                            "StartDate",
                          ]);
                        }}
                        format="DD-MM-YYYY"
                        inputReadOnly
                      />
                    </Form.Item>

                    {/* TODO: Add an Upload Section for Image */}

                    <Form.Item
                      name="EmploymentTypeId"
                      style={{ marginBottom: "10px" }}
                      rules={[
                        {
                          required: true,
                          message: "Please Select Employment Status!",
                        },
                      ]}
                      label="Employee Status"
                    >
                      <Select
                        placeholder="Select Status"
                        showSearch
                        allowClear
                        mode="combobox"
                        size={"middle"}
                        filterOption={(input, option) =>
                          String(option.children)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {masterData?.EmploymentTypeMaster?.map(
                          (employmentStatus) => (
                            <Select.Option
                              key={employmentStatus.EmploymentTypeId}
                              value={employmentStatus.EmploymentTypeId}
                            >
                              {employmentStatus.EmploymentTypeName}
                            </Select.Option>
                          )
                        )}
                      </Select>
                    </Form.Item>
                    <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.EmploymentTypeId !==
                    currentValues.EmploymentTypeId
                  }
                >
                  {({ getFieldValue }) => (
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label={
                        getFieldValue("EmploymentTypeId") &&
                        masterData?.EmploymentTypeMaster?.find(
                          (status) =>
                            status.EmploymentTypeId ===
                            getFieldValue("EmploymentTypeId")
                        )?.EmploymentTypeName === "Probation" ? (
                          <span>
                            <span style={{ color: "red" }}>* </span>Probation
                            Period
                          </span>
                        ) : (
                          "Probation Period"
                        )
                      }
                      name="ProbationComplateDate"
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const employmentTypeId =
                              getFieldValue("EmploymentTypeId");
                            const isProbation =
                              masterData?.EmploymentTypeMaster?.find(
                                (status) =>
                                  status.EmploymentTypeId === employmentTypeId
                              )?.EmploymentTypeName === "Probation";
                            if (isProbation && !value) {
                              return Promise.reject(
                                new Error(
                                  "Probation date is required when Employment Status is Probation!"
                                )
                              );
                            }
                            const JoinDate = getFieldValue("JoinDate");
                            if (
                              !value ||
                              !JoinDate ||
                              value.isAfter(JoinDate)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                "Probation date must be after the joining date!"
                              )
                            );
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="date-picker hr-staffs-date-picker"
                        onChange={(date, dateString) =>
                          setProbationPeriod({ date: dateString })
                        }
                        format="DD-MM-YYYY"
                        inputReadOnly
                      />
                    </Form.Item>
                  )}
                </Form.Item>
                   <Form.Item
  name="DepartmentId"
  label="Department"
  rules={[
    {
      required: true,
      message: "Please Select Department!",
    },
  ]}
>
  <Select
    placeholder="Select Department"
    showSearch
    allowClear
    onChange={(value, option) => {
      // console.log("Selected Department:", value, option);
    }}
    filterOption={(input, option) =>
      String(option.children).toLowerCase().includes(input.toLowerCase())
    }
  >
    {masterData?.DepartmentMaster?.map((department) => (
      <Select.Option
        key={department.DepartmentId}
        value={department.DepartmentId}
      >
        {department.DepartmentName}
      </Select.Option>
    ))}
  </Select>
</Form.Item>
                    <Form.Item
                      rules={[
                        { required: true, message: "Please Select User Role!" },
                      ]}
                      label="Role"
                      name="RoleId"
                      style={{ marginBottom: "10px" }}
                    >
                      <Select
                        size="middle"
                        allowClear
                        showSearch
                        style={{
                          width: "100%",
                        }}
                        placeholder="Please select"
                        filterOption={(input, option) =>
                          String(option.children)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {Array.isArray(rolesList) && rolesList.map((role) => (
                          <Select.Option key={role.RoleId} value={role.RoleId}>
                            {role.RoleName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Personal Email"
                      name="EmailId"
                      rules={[
                        { required: true, message: "Please input email!" },
                        {
                          type: "email",
                          message: "Please enter a valid email!",
                        },
                        { validator: validateUniqueEmail },
                      ]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="PF Eligibility"
                      name="IsPfDeducted"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select PF eligibility!",
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder="Select PF eligibility"
                        showSearch
                        allowClear
                        mode="combobox"
                      >
                        <Option value={true}>Yes</Option>
                        <Option value={false}>No</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="LeavePolicyGroupId"
                      style={{ marginBottom: "10px" }}
                      label="Leave Policy"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please Select Leave Policy!",
                      //   },
                      // ]}
                    >
                      <Select
                        // loading={!officeName}
                        placeholder="Select leave Policy"
                        showSearch
                        allowClear
                        filterOption={(input, option) =>
                          String(option.children)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        size="middle"
                      >
                        {leavePolicyGroup?.map((LeavePolicy) => (
                          <Select.Option
                            key={LeavePolicy.LeavePolicyGroupId}
                            value={LeavePolicy.LeavePolicyGroupId}
                          >
                            {LeavePolicy.LeavePolicyGroupName}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {/* Payment Type Field */}
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Payment Type"
                      name="PaymentTypeId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please select Payment Type!",
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder="Select Payment Type"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        options={paymentTypeOptions}
                      />
                    </Form.Item>

                    <Form.Item
                      name="CompanyOfficeId"
                      style={{ marginBottom: "10px" }}
                      label="Office"
                      rules={[
                        { required: true, message: "Please Select Office!" },
                      ]}
                    >
                      <Select
                        placeholder="Select Office"
                        allowClear
                        size="middle"
                        {...SEARCHABLE_SELECT_PROPS}
                        options={officeOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Employee Code"
                      name="EmployeeCode"
                      rules={[
                        {
                          required: true,
                          message: "Please input Employee Code!",
                        },
                      ]}
                    >
                      <Input placeholder="Emp-001" />
                    </Form.Item>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Is ESIC Deducted"
                      name="IsEsicDeducted"
                      // rules={[
                      //   { required: true, message: "Please select ESIC option!" },
                      // ]}
                    >
                      <Select
                        placeholder="Select ESIC option"
                        className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                      >
                        <Option value={true}>Yes</Option>
                        <Option value={false}>No</Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="ESIC"
                      name="EsicNumber"
                      // rules={[
                      // 	{ required: true, message: "Please input ESIC!" },

                      // ]}
                    >
                      <Input placeholder="ESIC" />
                    </Form.Item>
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Reporting Manager "
                      name="ReportingToId"
                      rules={[
                        {
                          required: true,
                          message: "Please select a user!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Reporting Manager"
                        allowClear
                        {...SEARCHABLE_SELECT_PROPS}
                        options={reportingManagerOptions}
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please Select User Shift!",
                        },
                      ]}
                      label="Shift"
                      name="ShiftId"
                      style={{ marginBottom: "10px" }}
                    >
                      <Select
                        // loading={!shift}
                        size="middle"
                        showSearch
                        allowClear
                        style={{
                          width: "100%",
                        }}
                        placeholder="Please select"
                        filterOption={(input, option) =>
                          String(option.children)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {shift &&
                          shift?.map((shift) => (
                            <Select.Option
                              key={shift.ShiftId}
                              value={shift.ShiftId}
                            >
                              {shift.ShiftName}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please Select Working days!",
                        },
                      ]}
                      label="Working Days"
                      showSearch
                      allowClear
                      mode="combobox"
                      name={"WeeklyWorkingDaysId"}
                      style={{ marginBottom: "10px" }}
                    >
                      <Select
                        loading={!weeklyHoliday}
                        size="middle"
                        showSearch
                        allowClear
                        style={{
                          width: "100%",
                        }}
                        placeholder="Please select"
                        filterOption={(input, option) =>
                          String(option.children)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {weeklyHoliday &&
                          weeklyHoliday.map((weeklyHoliday) => (
                            <Select.Option
                              key={weeklyHoliday.WeeklyWorkingDaysId}
                              value={weeklyHoliday.WeeklyWorkingDaysId}
                            >
                              {weeklyHoliday.WeeklyWorkingDaysName}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="Official Email"
                      name="OfficialMailId"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input Official email!",
                      //   },
                      //   {
                      //     type: "email",
                      //     message: "Please enter a valid Official email!",
                      //   },
                      //   { validator: validateUniqueEmail },
                      // ]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      label="UAN"
                      name="UanNumber"
                      // rules={[
                      //   // { required: true, message: "Please input UAN!" },
                      //   {
                      //     pattern: /^[0-9]{12}$/,
                      //     message: "Please enter a valid 12-digit UAN!",
                      //   },
                      // ]}
                    >
                      <Input placeholder="Enter UAN" maxLength={12} />
                    </Form.Item>
                    {/* <Form.Item
                      style={{ marginBottom: "10px" }}
                      label=" Probation Period"
                      name="ProbationComplateDate "
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const JoinDate = getFieldValue("JoinDate");
                            if (
                              !value ||
                              !JoinDate ||
                              value.isAfter(JoinDate)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(
                                "Probation date must be After the joining date!"
                              )
                            );
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="date-picker hr-staffs-date-picker"
                        onChange={(date, dateString) =>
                          setProbationPeriod({ date: dateString })
                        }
                        // onChange={(date) => {
                        // 	setProbationPeriod({ date });
                        // }}
                        format="DD-MM-YYYY"
                        inputReadOnly
                      />
                    </Form.Item> */}
                  </Col>
                </Row>
              </Col>
            </TabPane>

            <TabPane
              tab="Designation Information"
              key="5"
              disabled={isTabDisabled("5")}
            >
              <Col span={12} className="gutter-row">
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Designation Information
                </h2>

                <Form.Item
                  rules={[
                    { required: true, message: "Please Select Designation!" },
                  ]}
                  label="Designation"
                  name="DesignationId"
                  style={{ marginBottom: "10px" }}
                >
                  <Select
                    loading={!shift}
                    size="middle"
                    showSearch
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select Designation"
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {/* {designation &&
                      designation.map((designation) => (
                        <Select.Option
                          key={designation.id}
                          value={designation.id}
                        >
                          {designation.name}
                        </Select.Option>
                      ))} */}
                    {masterData?.DesignationMaster?.map((designation) => (
                      <Select.Option
                        key={designation.DesignationId}
                        value={designation.DesignationId}
                      >
                        {designation.DesignationName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Start Date"
                  name="StartDate"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const JoinDate = getFieldValue("JoinDate");
                        if (!value || !JoinDate) {
                          return Promise.resolve();
                        }
                        if (value.unix() >= JoinDate.unix()) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Start date must be after or equal to the joining date!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    className="date-picker hr-staffs-date-picker"
                    // onChange={(date, dateString) => {
                    // 	setDesignationStartDate({ date: dateString });
                    // 	form.validateFields(['JoinDate']);
                    // }}
                    onChange={(date, dateString) => {
                      setDesignationStartDate({ date: dateString });
                      // console.log("designationDate", designationStartDate);
                    }}
                    format="DD-MM-YYYY"
                    inputReadOnly
                  />
                </Form.Item>

                {/* <Form.Item
										style={{ marginBottom: "10px" }}
										label='End Date'
										name='EndDate'>
										<DatePicker className='date-picker hr-staffs-date-picker' />
									</Form.Item> */}
              </Col>
            </TabPane>

            <TabPane
              tab="Salary Information"
              key="6"
              disabled={isTabDisabled("6")}
            >
              <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                Salary Information
              </h2>
              <br />
              <Col span={12} className="gutter-row">
                <Form.Item
                  label="Salary Start Date"
                  name="startDate"
                  style={{ marginBottom: "10px" }}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input Probation Period date!",
                  //   },
                  //   ({ getFieldValue }) => ({
                  //     validator(_, value) {
                  //       const JoinDate = getFieldValue("JoinDate");
                  //       if (!value || !JoinDate) {
                  //         return Promise.resolve();
                  //       }
                  //       if (value.unix() >= JoinDate.unix()) {
                  //         return Promise.resolve();
                  //       }
                  //       return Promise.reject(
                  //         new Error(
                  //           "Probation period end date must be after or equal to the joining date!"
                  //         )
                  //       );
                  //     },
                  //   }),
                  // ]}
                >
                  <DatePicker
                    className="date-picker hr-staffs-date-picker"
                    // onChange={(date, dateString) => {
                    // 	setSalaryStartDate({ date: dateString });
                    // 	form.validateFields(['JoinDate']);
                    // }}
                    onChange={(date, dateString) => {
                      setSalaryStartDate({ date: dateString });
                      form.validateFields(["JoinDate"]);
                    }}
                    format="DD-MM-YYYY"
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <hr />
              <br />

              <Row gutter={24}>
                <Col span={12}>
                  <h3 className="text-center text-xl mt-3 mb-3 txt-color">
                    Income
                  </h3>
                  {salaryComponentData
                    ?.filter(
                      (component) => component?.componentType === "Income"
                    )
                    .map((component, index) => (
                      <Form.Item
                        key={index}
                        style={{ marginBottom: "10px" }}
                        label={component.componentName}
                        name={`salaryComponents.${component.componentName}`}
                        // rules={[
                        // 	{
                        // 		required: true,
                        // 		message: `Please input ${component.componentName}!`,
                        // 	},
                        // ]}>
                      >
                        <InputNumber
                          min={0}
                          step={0.01}
                          style={{ width: "100%" }}
                          placeholder={component.componentName}
                          addonAfter={
                            component.calculationType === "% of Basic"
                              ? "% of Basic"
                              : null
                          }
                        />
                      </Form.Item>
                    ))}

                  <br />
                </Col>
                <Col span={12}>
                  <h3 className="text-center text-xl mt-3 mb-3 txt-color">
                    Deduction
                  </h3>
                  {salaryComponentData
                    ?.filter(
                      (component) => component.componentType === "Deduction"
                    )
                    .map((component, index) => (
                      <Form.Item
                        key={index}
                        style={{ marginBottom: "10px" }}
                        label={component.componentName}
                        name={`salaryComponents.${component.componentName}`}
                        // rules={[
                        // 	{
                        // 		required: true,
                        // 		message: `Please input ${component.componentName}!`,
                        // 	},
                        // ]}>
                      >
                        <InputNumber
                          min={0}
                          step={0.01}
                          style={{ width: "100%" }}
                          placeholder={component.componentName}
                          addonAfter={
                            component.calculationType === "% of Basic"
                              ? "% of Basic"
                              : null
                          }
                        />
                      </Form.Item>
                    ))}

                  <br />
                </Col>
              </Row>

              <hr />
              <br />
              <Row gutter={24}>
                <Col span={12}>
                  {salaryComponentData
                    ?.filter(
                      (component) => component.componentType === "Income"
                    )
                    .map((component, index) => {
                      if (component.calculationType === "% of Basic") {
                        return (
                          <Form.Item
                            key={index} // To provide a unique key for each mapped element
                            style={{ marginBottom: "10px" }}
                            label={`${component.componentName} Amount`}
                            name={`salaryComponents.${component.componentName}Amount`}
                            initialValue={0} // Initial value set to 0
                            // rules={[
                            // 	{
                            // 		required: true,
                            // 		message: `Please input ${component.componentName} Amount!`,
                            // 	},
                            // ]}
                          >
                            <InputNumber
                              disabled // Disable input for calculated amounts
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        );
                      } else {
                        return null; // Return null for elements that don't match the condition
                      }
                    })}
                </Col>
                <Col span={12}>
                  {salaryComponentData
                    ?.filter(
                      (component) => component.componentType === "Deduction"
                    )
                    .map((component, index) => {
                      if (component.calculationType === "% of Basic") {
                        return (
                          <Form.Item
                            key={index}
                            style={{ marginBottom: "10px" }}
                            label={`${component.componentName} Amount`}
                            name={`salaryComponents.${component.componentName}Amount`}
                            initialValue={0}
                            // rules={[
                            // 	{
                            // 		required: true,
                            // 		message: `Please input ${component.componentName} Amount!`,
                            // 	},
                            // ]}
                          >
                            <InputNumber disabled style={{ width: "100%" }} />
                          </Form.Item>
                        );
                      } else {
                        return null;
                      }
                    })}
                </Col>
              </Row>

              <hr />
              <br />
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="CTC" name="ctc">
                    <InputNumber
                      defaultValue={salaryData.ctc}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="In Hand Salary" name="inHandSalary">
                    <InputNumber
                      defaultValue={salaryData.inHandSalary}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Bank Details" key="7" disabled={isTabDisabled("7")}>
              <Col span={12} className="gutter-row form-color">
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Bank Details
                </h2>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Account Holder Name"
                  name="accountHolderName"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input Account Holder Name!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Account Holder Name" />
                </Form.Item>

                {/* <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Bank Name"
                  name="bankName"
                  rules={[
                    {
                      required: true,
                      message: "Please input Bank Name!",
                    },
                  ]}
                >
                  <Input placeholder="Bank Name" />
                </Form.Item> */}

                <Form.Item
                  name="BankNameId"
                  style={{ marginBottom: "10px" }}
                  label="Bank Name"
                  // rules={[{ required: true, message: "Please Select Bank!" }]}
                >
                  <Select
                    // loading={!officeName}
                    placeholder="Select Bank"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      String(option.children)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    size="middle"
                  >
                    {masterData?.BankTypeMaster?.map((bank) => (
                      <Select.Option
                        key={bank.BankTypeId}
                        value={bank.BankTypeId}
                      >
                        {bank.BankTypeName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Account Number"
                  name="accountNumber"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input Account Number!",
                  //   },
                  //   {
                  //     pattern: /^[0-9]{9,18}$/,
                  //     message:
                  //       "Please enter a valid account number (9-18 digits)!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Account Number" maxLength={18} />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="IFSC Code"
                  name="IFSC_code"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input IFSC Code!",
                  //   },
                  //   {
                  //     pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                  //     message: "Please enter a valid IFSC code!",
                  //   },
                  // ]}
                >
                  <Input placeholder="IFSC Code" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Branch Name"
                  name="branchName"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input Branch Name!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Branch Name" />
                </Form.Item>
              </Col>
            </TabPane>
            <TabPane
              tab="Upload Document"
              key="8"
              disabled={isTabDisabled("8")}
            >
              <h2 className="text-center text-xl mt-3 mb-5 txt-color">
                Upload Document
              </h2>
              <div className="text-center">
                <p className="text-red-500 text-base mb-4">
                  Please Upload Document using the button below
                </p>
              </div>

              <Form.List name="documents">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, formItemProps, fieldData }) => (
                      <Space
                        key={key}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...formItemProps}
                          label="Document Type"
                          name={[name, "documentName"]}
                          rules={[
                            {
                              required: true,
                              message: "Please select the Document type!",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Document Type"
                            showSearch
                            allowClear
                            mode="combobox"
                          >
                            <Select.Option value="Aadhar">Aadhar</Select.Option>
                            <Select.Option value="PAN">PAN</Select.Option>
                            <Select.Option value="10th Certificate">
                              10th Certificate
                            </Select.Option>
                            <Select.Option value="12th Certificate">
                              12th Certificate
                            </Select.Option>
                            <Select.Option value="Other">Other</Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) =>
                            prevValues.documentName !==
                            currentValues.documentName
                          }
                        >
                          {({ getFieldValue }) =>
                            getFieldValue([name, "documentName"]) ===
                            "Other" ? (
                              <Form.Item
                                name={[name, "otherDocumentName"]}
                                label="Enter Document Type"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter the document type",
                                  },
                                ]}
                              >
                                <Input placeholder="Enter document type" />
                              </Form.Item>
                            ) : null
                          }
                        </Form.Item>

                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Upload Document"
                          required={false}
                        >
                          <Dragger
                            listType="picture-card"
                            beforeUpload={() => false}
                            name="file"
                            fileList={fieldData?.thumbFileList}
                            onChange={(info) => handleFileUpload(info, key)}
                            maxCount={1}
                          >
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-hint">
                              Support for a single upload.
                            </p>
                          </Dragger>
                        </Form.Item>

                        <MinusCircleOutlined
                          className="txt-color"
                          style={{ fontSize: "150%" }}
                          onClick={() => remove(name)}
                        />
                      </Space>
                    ))}

                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      wrapperCol={{
                        offset: 4,
                        span: 16,
                      }}
                    >
                      <Button
                        type="dashed"
                        size="middle"
                        style={{ color: "#fff", backgroundColor: "#2c3e50" }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Document
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>

              <br />
              <hr />
              <br />
              <Form.Item
                style={{ marginBottom: "10px", marginTop: "20px" }}
                wrapperCol={{ offset: 4, span: 16 }}
              ></Form.Item>
            </TabPane>

            <TabPane
              tab="Education Information"
              key="9"
              disabled={isTabDisabled("9")}
            >
              <h2 className="text-center text-xl mt-3 mb-5 txt-color">
                Education Information
              </h2>
              <div className="text-center">
                <p className="text-red-500 text-base mb-4">
                  Please add education information using the button below
                </p>
              </div>
              <Form.List name="educations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <EmployeeEducationForm
                        key={key}
                        name={name}
                        remove={remove}
                        restField={restField}
                      />
                    ))}
                    <Form.Item
                      style={{ marginBottom: "10px" }}
                      wrapperCol={{
                        offset: 4,
                        span: 16,
                      }}
                    >
                      <Button
                        type="dashed"
                        size="middle"
                        style={{ color: "#fff", backgroundColor: "#2c3e50" }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Education Information
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <br />
              <hr /> <hr /> <hr /> <hr />
              <br />
              <Form.Item
                style={{ marginBottom: "10px", marginTop: "20px" }}
                wrapperCol={{ offset: 4, span: 16 }}
              >
                <Button
                  size="large"
                  onClick={() => setLoader(true)}
                  block
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  loading={loader}
                >
                  Add New Staff
                </Button>
              </Form.Item>
            </TabPane>
          </Tabs>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button onClick={handlePrevious} disabled={currentTab === "1"}>
              Previous
            </Button>
            <Button onClick={handleNext} disabled={currentTab === "9"}>
              Next
            </Button>
          </div>
        </Form>
      </div>
      {/* </UserPrivateComponent> */}
    </Fragment>
  );
});

AddUser.displayName = 'AddUser';

export default AddUser;
